/* v8 ignore file -- @preserve */
export default function focusAfterTransition({ query, panelClass = '.transition-panel', timeout = 500, preventScroll = true }) {
  const find = () => document.querySelector(query);

  const finish = (el) => {
    if (!el) return;

    el.focus({ preventScroll });
  };

  const waitAnimation = (el) => {
    requestAnimationFrame(() => {
      const panel = el.closest(panelClass);

      if (!panel) {
        finish(el);
        return;
      }

      const style = window.getComputedStyle(panel);
      const duration = parseFloat(style.animationDuration || '0');

      if (!duration || style.animationName === 'none') {
        finish(el);
        return;
      }

      panel.addEventListener('animationend', () => finish(el), { once: true });
    });
  };

  const existing = find();

  if (existing) {
    waitAnimation(existing);
    return;
  }

  const observer = new MutationObserver(() => {
    const el = find();

    if (el) {
      observer.disconnect();
      waitAnimation(el);
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  setTimeout(() => {
    observer.disconnect();
  }, timeout);
}
